import { render, staticRenderFns } from "./JurnalKelasList.vue?vue&type=template&id=25197547"
import script from "./JurnalKelasList.vue?vue&type=script&lang=js"
export * from "./JurnalKelasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports